import {
    Box,
    Button,
    Container,
    createTheme,
    makeStyles,
    ThemeProvider,
    Typography
} from '@material-ui/core';
// import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import confetti from "canvas-confetti";
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import logo from '../assets/img/logol.png';

const theme = createTheme({
    palette: {
        primary: {
            main: '#EC4899',
        },
        secondary: {
            main: '#10B981',
        },
        background: {
            default: '#FAF5FF',
        },
        text: {
            primary: '#1F2937',
            secondary: '#6B7280',
        },
    },
    typography: {
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontWeight: 700,
        },
        h5: {
            fontWeight: 600,
        },
        h6: {
            fontWeight: 600,
        },
    },
    shape: {
        borderRadius: 16,
    },
});

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100vh',
        background: 'linear-gradient(241deg, #9167e440 0%, #F0F9FF 50%, #ed5e8e4d 100%)',
        padding: theme.spacing(4, 2),
    },
    header: {
        marginBottom: theme.spacing(6),
    },
    logo: {
        fontSize: '1.5rem',
        fontWeight: 700,
        color: theme.palette.primary.main,
    },
    successIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 80,
        height: 80,
        borderRadius: '50%',
        backgroundColor: 'rgba(236, 72, 153, 0.12)',
        margin: '0 auto',
        marginBottom: theme.spacing(3),
        animation: '$fadeIn 0.6s ease-out',
    },
    checkIcon: {
        fontSize: 40,
        color: theme.palette.primary.main,
    },
    thankYouTitle: {
        fontSize: '3rem',
        fontWeight: 700,
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(2),
        animation: '$slideUp 0.6s ease-out',
        [theme.breakpoints.down('sm')]: {
            fontSize: '2.25rem',
        },
    },

    subtitle: {
        fontSize: '1.125rem',
        color: theme.palette.text.secondary,
        maxWidth: 600,
        margin: '0 auto',
        marginBottom: theme.spacing(6),
        animation: '$slideUp 0.6s ease-out 0.1s both',
        lineHeight: 1.6,
        textAlign: 'left',
    },
    loginButton: {
        marginTop: theme.spacing(2),
        backgroundColor: theme.palette.primary.main,
        color: '#fff',
        padding: theme.spacing(1.75, 4),
        borderRadius: 12,
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '1rem',
        boxShadow: '0 4px 20px rgba(236, 72, 153, 0.3)',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            transform: 'scale(1.02)',
        },
        transition: 'all 0.2s ease',
    },

    card: {
        padding: theme.spacing(4),
        borderRadius: 24,
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        backdropFilter: 'blur(10px)',
        boxShadow: '0 8px 40px rgba(0, 0, 0, 0.08)',
        height: '100%',
        animation: '$slideUp 0.6s ease-out 0.2s both',
    },
    cardSecond: {
        animationDelay: '0.3s',
    },
    iconCircleGreen: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 56,
        height: 56,
        borderRadius: 16,
        backgroundColor: 'rgba(16, 185, 129, 0.15)',
        marginBottom: theme.spacing(2.5),
    },
    iconCirclePink: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 56,
        height: 56,
        borderRadius: 16,
        backgroundColor: 'rgba(236, 72, 153, 0.15)',
        marginBottom: theme.spacing(2.5),
    },
    cardTitle: {
        fontSize: '1.25rem',
        fontWeight: 600,
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(1.5),
    },
    cardDescription: {
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(3),
        lineHeight: 1.6,
    },
    whatsappButton: {
        backgroundColor: '#059669',
        color: '#fff',
        padding: theme.spacing(1.75, 3),
        borderRadius: 12,
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '1rem',
        width: '100%',
        boxShadow: '0 4px 20px rgba(16, 185, 129, 0.3)',
        '&:hover': {
            backgroundColor: '#059669',
            transform: 'scale(1.02)',
        },
        transition: 'all 0.2s ease',
    },
    demoButton: {
        backgroundColor: '#DB2777',
        color: '#fff',
        padding: theme.spacing(1.75, 3),
        borderRadius: 12,
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '1rem',
        width: '100%',
        boxShadow: '0 4px 20px rgba(236, 72, 153, 0.3)',
        '&:hover': {
            backgroundColor: '#DB2777',
            transform: 'scale(1.02)',
        },
        transition: 'all 0.2s ease',
    },
    buttonIcon: {
        marginRight: theme.spacing(1),
        fontSize: 20,
    },
    buttonArrow: {
        marginLeft: theme.spacing(1),
        fontSize: 20,
    },
    sectionTitle: {
        fontSize: '1.125rem',
        fontWeight: 500,
        color: theme.palette.text.secondary,
        textAlign: 'center',
        marginTop: theme.spacing(6),
        marginBottom: theme.spacing(4),
        animation: '$slideUp 0.6s ease-out 0.4s both',
    },
    featureCard: {
        padding: theme.spacing(3),
        borderRadius: 16,
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        backdropFilter: 'blur(10px)',
        boxShadow: '0 8px 40px rgba(0, 0, 0, 0.08)',
        textAlign: 'center',
        animation: '$slideUp 0.6s ease-out 0.5s both',
    },
    featureIconCircle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 48,
        height: 48,
        borderRadius: '50%',
        backgroundColor: 'rgba(107, 114, 128, 0.15)',
        margin: '0 auto',
        marginBottom: theme.spacing(2),
    },
    featureTitle: {
        fontWeight: 600,
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(1),
    },
    featureDescription: {
        fontSize: '0.875rem',
        color: theme.palette.text.secondary,
    },
    '@keyframes fadeIn': {
        from: { opacity: 0 },
        to: { opacity: 1 },
    },
    '@keyframes slideUp': {
        from: { opacity: 0, transform: 'translateY(20px)' },
        to: { opacity: 1, transform: 'translateY(0)' },
    },
}));

const fireCelebration = () => {
    const duration = 1800;
    const end = Date.now() + duration;

    const frame = () => {
        confetti({
            particleCount: 6,
            angle: 60,
            spread: 55,
            origin: { x: 0 },
            colors: ["#EC4899", "#10B981", "#6366F1", "#F59E0B"],
        });

        confetti({
            particleCount: 6,
            angle: 120,
            spread: 55,
            origin: { x: 1 },
            colors: ["#EC4899", "#10B981", "#6366F1", "#F59E0B"],
        });

        if (Date.now() < end) {
            requestAnimationFrame(frame);
        }
    };

    frame();
};


const ThankYouPage = () => {
    const classes = useStyles();
    const history = useHistory();

    useEffect(() => {
        fireCelebration();
    }, []);
    return (
        <ThemeProvider theme={theme}>
            <Box className={classes.root}>
                <Container maxWidth="lg">
                    {/* Header */}
                    {/* <Box className={classes.header}>
                        <Typography className={classes.logo}><span style={{ color: '#3c83f6' }}>learning</span><span style={{ color: '#f59f0a' }}>Fitbit</span></Typography>
                    </Box> */}
                    <Box className={classes.header} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 40,
                                height: 40,
                                borderRadius: 10,
                                background: "linear-gradient(173deg, #6f41e37d 0%, #e7616930 100%)",     // 'linear-gradient(135deg, #7C3AED 0%, #10B981 100%)',
                                overflow: 'hidden'
                            }}
                        >
                            {/* <SchoolOutlinedIcon htmlColor='#fff' sx={{ fontSize: 24 }} /> */}
                            <img
                                src={logo}
                                alt="brand logo"
                                style={{
                                    width: "70%",
                                    height: "70%",
                                    objectFit: "contain",
                                }}
                            />
                        </Box>&nbsp;
                        <Typography variant="h6" fontWeight={700} sx={{ textTransform: 'none', marginLeft: '10px' }}>
                            <Box component="span" sx={{ color: '#3c83f6', textTransform: 'none' }}>learning</Box>
                            <Box component="span" sx={{ color: '#f59f0a', textTransform: 'capitalize' }}>Fitbit</Box>
                        </Typography>
                    </Box>

                    {/* Main Content */}
                    <Container maxWidth="md">
                        {/* Success Icon */}
                        <Box className={classes.successIcon}>
                            <CheckCircleOutlineIcon className={classes.checkIcon} />
                        </Box>

                        {/* Thank You Message */}
                        <Box textAlign="center">
                            <Typography className={classes.thankYouTitle}>
                                Welcome to LearningFitbit! 🎉
                            </Typography>

                            <Typography className={classes.subtitle} component="div">
                                <p>We’re excited to have you start your free trial with us.</p>

                                <p>
                                    You should have received an email at your registered email containing
                                    your login credentials along with the “Get Started” user manual.
                                    Please check your inbox (and spam folder, just in case).
                                </p>

                                <p>
                                    We are happy to support you for any assistance or additional details
                                    to make the most of this trial period!
                                </p>

                                <p>We wish you a great experience with LearningFitbit!</p>
                            </Typography>
                        </Box>

                        <Box textAlign="center">
                            <Button
                                className={classes.loginButton}
                                onClick={() => history.push('/auth')}
                            >
                                Go to Login
                            </Button>
                        </Box>


                        {/* Action Cards */}
                        {/* <Grid container spacing={3}> */}
                        {/* WhatsApp Card */}
                        {/* <Grid item xs={12} md={6}>
                                <Paper className={classes.card} elevation={0}>
                                    <Box className={classes.iconCircleGreen}>
                                        <WhatsAppIcon style={{ fontSize: 28, color: '#10B981' }} />
                                    </Box>
                                    <Typography className={classes.cardTitle}>
                                        Talk to Us on WhatsApp
                                    </Typography>
                                    <Typography className={classes.cardDescription}>
                                        Have questions? Chat with our team instantly. We're here to help you get started quickly.
                                    </Typography>
                                    <Button className={classes.whatsappButton}>
                                        <WhatsAppIcon className={classes.buttonIcon} />
                                        Start Chat
                                        <ArrowForwardIcon className={classes.buttonArrow} />
                                    </Button>
                                </Paper>
                            </Grid> */}

                        {/* Schedule Call Card */}
                        {/* <Grid item xs={12} md={6}>
                                <Paper className={`${classes.card} ${classes.cardSecond}`} elevation={0}>
                                    <Box className={classes.iconCirclePink}>
                                        <EventIcon style={{ fontSize: 28, color: '#EC4899' }} />
                                    </Box>
                                    <Typography className={classes.cardTitle}>
                                        Schedule a Call
                                    </Typography>
                                    <Typography className={classes.cardDescription}>
                                        Book a personalized demo to see how we can help transform your workflow.
                                    </Typography>
                                    <Button className={classes.demoButton}>
                                        <EventIcon className={classes.buttonIcon} />
                                        Book a Demo
                                        <ArrowForwardIcon className={classes.buttonArrow} />
                                    </Button>
                                </Paper>
                            </Grid> */}
                        {/* </Grid> */}

                        {/* What Happens Next Section */}
                        {/* <Typography className={classes.sectionTitle}>
                            What happens next?
                        </Typography> */}

                        {/* Feature Cards */}
                        {/* <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                                <Paper className={classes.featureCard} elevation={0}>
                                    <Box className={classes.featureIconCircle}>
                                        <WhatsAppIcon style={{ fontSize: 20, color: '#6B7280' }} />
                                    </Box>
                                    <Typography className={classes.featureTitle}>Quick Questions?</Typography>
                                    <Typography className={classes.featureDescription}>
                                        Get instant answers via WhatsApp
                                    </Typography>
                                </Paper>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Paper className={classes.featureCard} elevation={0}>
                                    <Box className={classes.featureIconCircle}>
                                        <PeopleOutlineIcon style={{ fontSize: 20, color: '#6B7280' }} />
                                    </Box>
                                    <Typography className={classes.featureTitle}>See It In Action</Typography>
                                    <Typography className={classes.featureDescription}>
                                        Book a personalized demo call
                                    </Typography>
                                </Paper>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Paper className={classes.featureCard} elevation={0}>
                                    <Box className={classes.featureIconCircle}>
                                        <FlashOnIcon style={{ fontSize: 20, color: '#6B7280' }} />
                                    </Box>
                                    <Typography className={classes.featureTitle}>Fast Response</Typography>
                                    <Typography className={classes.featureDescription}>
                                        We typically respond within minutes
                                    </Typography>
                                </Paper>
                            </Grid>
                        </Grid> */}
                    </Container>
                </Container>
            </Box>
        </ThemeProvider>
    );
};

export default ThankYouPage;
